var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#A5A4A1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.56 8.94L3.5 8L5.56 7.06L6.5 5L7.44 7.06L9.5 8L7.44 8.94L6.5 11L5.56 8.94ZM6.5 21L7.44 18.94L9.5 18L7.44 17.06L6.5 15L5.56 17.06L3.5 18L5.56 18.94L6.5 21ZM2.87 12.37L1.5 13L2.87 13.63L3.5 15L4.13 13.63L5.5 13L4.13 12.37L3.5 11L2.87 12.37ZM10.5 12C10.5 8.91 11.88 6.06 13.94 4H10.5V2H17.5V9H15.5V5.28C13.7 7.02 12.5 9.48 12.5 12C12.5 15.32 14.6 18.36 17.5 19.82V22C13.41 20.41 10.5 16.35 10.5 12ZM22.5 14H20.5V12H18.5V14H16.5V16H18.5V18H20.5V16H22.5V14Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVport);
export default __webpack_public_path__ + "static/media/icon_vport.3e317cc7.svg";
export { ForwardRef as ReactComponent };